<template>
  <div class="root d-inline-block">
    <div class="input-group">
      <div v-if="mode==='view'">
        <div v-if="user.haveCompanyPost">
          <button class="btn btn-secondary" @click="openModal('view')">
            <i class="icon-eye-outline"></i>
          </button>
        </div>
        <div v-if="!user.haveCompanyPost">ندارد</div>
      </div>

      <button v-if="mode==='create'" class="btn btn-success" @click="openModal('create')">
        <i class="icon-content-duplicate"></i>
      </button>
      <button v-if="mode==='edit' && user.id" class="btn btn-secendory" @click="openModal('edit')">
        <i class="icon-bd-pencil"></i>
      </button>
    </div>
    <b-modal ref="userRoleModal" id="modal-center" class="accounting-modal" centered size="lg" :title="modalTitle"
             :ok-title="'ذخیره'" :cancel-title="'لغو'" @ok="onuserRoleModalOk">
      <vs-table v-if="show" ref="userRoleTable" :params="tableParams" :options="tableOptions"></vs-table>
    </b-modal>
  </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from "vuex";
    import BaseService from "../_framework/api/BaseService.js";
    import Utils from "../_framework/utils/Utils.js";
    import VsSelect from "../_framework/VsSelect";
    import VsTableMixin from "../_framework/VsTableMixin.js";
    import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
    import Products from "../pages/Products.vue";
    import EventBus from "../bus.js";

    export default {
        name: "user-roles",
        props: {
            headerKey: null,
            row: null,
            mode: {
                default: "view",
                type: String
            },
            params: {},
            entity: ""
        },
        mixins: [VsTableMixin],
        components: {
            VsSelect,
            datePicker: DatePicker
        },
        data() {
            return {
                userId: 0,
                show: true,
                user: {},
                servicesList: [],
                selectedValue: '',
                posts: [
                    {
                        userId: 0,
                        postId: 0,
                        companyId: null,
                        outSourceId: null
                    }
                ],
                tableParams: {
                    list: [],
                    // entity: "CompanyUserPost",
                    headers: {
                        company: {
                            title: "شرکت داخلی",
                            type: "custom",
                            component: "vs-select",
                            multiple: false,
                            label: "companyName",
                            inHeader: true,
                            listParams: {
                                requestURI: 'company/getAll'
                            },
                            rowAlignment: "center"
                        },
                        outSource: {
                            title: "شرکت خارجی",
                            type: "custom",
                            component: "vs-select",
                            multiple: false,
                            label: "outSourceName",
                            inHeader: true,
                            listParams: {
                                requestURI: 'OutSource'
                            },
                            rowAlignment: "center"
                        },
                        post: {
                            title: "سمت",
                            type: "custom",
                            component: "vs-select",
                            multiple: false,
                            label: "name",
                            inHeader: true,
                            listParams: {
                                requestURI: "access/GetAsDropdown"
                            },
                            rowAlignment: "center"
                        }
                    }
                },
                tableOptions: {
                    dataSourceType: "api",
                    beforeCreateEntity: input => {
                        const model = {
                            post: input.post,
                            company: input.company,
                            outSource: input.outSource
                        };
                        this.insertRow(model);
                        return null;

                       /* if (this.mode === "create") {
                            const model = {
                                post: input.post,
                                company: input.company,
                                outSource: input.outSource
                            };
                            this.insertRow(model);
                            return null;
                        } else {
                            input = {
                                userId: input.userId,
                                post: input.post,
                                company: input.company,
                                outSource: input.outSource,
                            };
                            return input;
                        }*/
                    },
                    beforeUpdateEntity: input => {
                        if (this.mode !== "create") return null;
                        const model = {
                            post: input.post,
                            company: input.company,
                            outSource: input.outSource
                        };
                        this.insertRow(model);
                        return null;

                        /*if (this.mode === "create") {
                            this.insertRow({
                                userId: input.userId,
                                post: input.post,
                                company: input.company,
                                outSource: input.outSource,
                            });
                            return null;
                        } else {
                            input = {
                                userId: input.userId,
                                post: input.post,
                                company: input.company,
                                outSource: input.outSource,
                            };
                            return input;
                        }*/
                    },
                    beforeFetchEntityList: input => {
                        if (this.user && this.user.id) input.userId = this.user.id;
                        return input;
                    },
                    hasActions: false,
                    onRowClicked: row => {
                    },
                    hasActionsInHeader: true,
                    clickableRows: true,
                }
            };
        },
        mounted() {
            // this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
            // console.log(this.user)
        },
        beforeMount() {
            if (this.row) {
                this.user = this.row;
            }
            this.tableOptions.access = checkAccess(this.$route.path);
        },
        methods: {
            refreshTable() {
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
                // this.$refs.table.onFetchEntityList();
            },
            getCompanyPosts() {
                let model = {
                    userId: this.user.id,
                    pageIndex: 0,
                    pageSize: 12
                };
                new BaseService('CompanyUserPost/').getList(model).then((response) => {

                    for (let item of response.data.data) {
                        this.insertRow({
                            company: item.company,
                            outSource: item.outSource,
                            post: item.post
                        });
                    }
                }).catch((error) => {
                    console.log(error)
                })
            },
            openModal(mode) {

                // this.tableOptions.hasActions = false;
                this.tableOptions.isEditable = false;
                // this.tableOptions.hasActionsInHeader = true;
                this.tableOptions.headerActionsMode = mode;
                if (mode === "create") {
                    this.tableOptions.clearStoreOnMount = true;
                    this.tableOptions.dataSourceType = "store";
                    this.tableOptions.hasActions = true;
                    this.tableOptions.hasActionsInHeader = true;
                } else {
                    this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
                    this.getCompanyPosts();
                    this.tableOptions.dataSourceType = "store";
                    if (mode === "view") {
                        this.tableOptions.hasActions = false;
                        this.tableOptions.hasActionsInHeader = false;
                    } else {
                        this.tableOptions.hasActions = true;
                        this.tableOptions.hasActionsInHeader = true;
                    }
                }
                this.$refs.userRoleModal.show();
                if (this.$refs.userRoleTable) {
                    this.$refs.userRoleTable.onFetchEntityListRequested();
                }
                this.refreshUserRoleTable();
            },
            btnClicked() {
                this.$refs.userRoleModal.show();
                this.calculatePrependWidth();
            },
            onuserRoleModalOk() {
                this.$emit(
                    "dataChanged",
                    this.headerKey,
                    this.vsTableFeed.map(m => {
                        return m;
                    })
                );
            },
            insertRow(data) {
                if (data !== null) {
                    this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
                        id: Math.round(Math.random() * 1000),
                        company: data.company,
                        outSource: data.outSource,
                        post: data.post
                    });
                }
            },
            deleteuserRoleTableRow(id) {
                this.$store.commit(
                    "RESET_VS_TABLE_FEED",
                    this.vsTableFeed.filter(ur => {
                        return ur.id !== id;
                    })
                );
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
            },
            refreshUserRoleTable() {
                if (this.$refs.userRoleTable) {
                    this.$refs.userRoleTable.onFetchEntityList();
                }
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
            }
        },
        computed: {
            ...mapState(["selectedRows", "currentService", "vsTableFeed"]),
            modalTitle() {
                if (this.user.userName) {
                    return "سمت های " + this.user.userName;
                } else {
                    return "سمت ها";
                }
            }
        }
    };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
